import { setSettings } from "store/features/memeGenerator/actions";
import { TextBox } from "store/features/memeGenerator/types";
import { useAppDispatch } from "store/store";

export const useBold = (textBox: TextBox) => {
    const isActive = textBox.decoration.bold;
    const dispatch = useAppDispatch();
    function handleClick() {
        dispatch(
            setSettings({
                id: textBox.id,
                decoration: textBox.decoration
                    ? {
                          ...textBox.decoration,
                          bold: !textBox.decoration.bold,
                      }
                    : {
                        underline: false,
                          italic: false,
                          bold: true,
                      },
            }),
        );
    }
    return {
        isActive,
        handleClick,
    };
};
